import { render } from "./InputRut.vue?vue&type=template&id=bde8e432&scoped=true"
import script from "./InputRut.vue?vue&type=script&lang=js"
export * from "./InputRut.vue?vue&type=script&lang=js"

import "./InputRut.vue?vue&type=style&index=0&id=bde8e432&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde8e432"]])

export default __exports__